import React from 'react';
import { Helmet } from 'react-helmet-async';

const LocalBusinessSchema = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "PrintShop"],
    "name": "Xerowrite",
    "description": "The highest-performing direct mail postcard with variable fluorescent pink highlighter and handwritten-style personalization. Serving businesses across all 50 states.",
    "url": "https://xerowrite.com",
    "telephone": "+1-801-509-7884",
    "email": "mail@xerowrite.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "1575 S River Rd.",
      "addressLocality": "St. George",
      "addressRegion": "UT",
      "postalCode": "84790",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 37.0965,
      "longitude": -113.5841
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "09:00",
        "closes": "17:30"
      }
    ],
    "priceRange": "$$",
    "areaServed": {
      "@type": "Country",
      "name": "United States"
    },
    "serviceType": [
      "Direct Mail Printing",
      "Handwritten Direct Mail Postcards",
      "Variable Data Printing"
    ],
    "knowsAbout": [
      "Direct Mail Marketing",
      "Print Production",
      "Personalized Marketing"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSchema;
